import { render, staticRenderFns } from "./minute.vue?vue&type=template&id=8e4c4dd4&scoped=true&"
import script from "./minute.vue?vue&type=script&lang=js&"
export * from "./minute.vue?vue&type=script&lang=js&"
import style0 from "./minute.vue?vue&type=style&index=0&id=8e4c4dd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4c4dd4",
  null
  
)

export default component.exports